'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchPeon = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.doFetch = doFetch;
exports.memoizeFetch = memoizeFetch;

var _Configure = require('../Configure');

var _Memoizer = require('../Memoizer');

var _rx = require('rx');

/* D.J. Funky Fetch (Fetch Wrapper)
 * - - - - - - - - - - - - - - - - -
 * @param {string} uri  Required fetch() URI.
 * @param {object|null} data  Optional fetch() data.
 * @param {bool|null} wantJSON  If given null, defaults to true.
 * @param {object|null} timeoutOpts  Optional arguments for timing out the
 *                                   fetch() Observable, of the form {
 *                                     dueTime:  <int>,      // milliseconds
 *                                     stream: <Observable>, // other stream
 *                                   }
 * @return {observable}
 */
function doFetch(uri, data, wantJSON, timeoutOpts) {
  wantJSON = wantJSON === false ? false : true;

  if (typeof fetch !== 'function') {
    return _rx.Observable.throw(new Error('Fetch is not defined.'));
  }

  var fetchStream = _rx.Observable.fromPromise(
  // Do a then here, that way resp.json() won't get called multiple times.
  fetch(uri, data).then(function (resp) {
    if (resp.status >= 500) {
      if ((0, _Configure.getConfigs)().redirectUrl) {
        window.location.replace((0, _Configure.getConfigs)().redirectUrl);
      }
      var error = new Error(uri + ' -> ' + resp.status + ': ' + resp.statusText);
      error.response = resp;
      throw error;
    }

    return wantJSON === false ? resp : resp.json();
  }));

  return (typeof timeoutOpts === 'undefined' ? 'undefined' : _typeof(timeoutOpts)) === 'object' ? fetchStream.timeout(timeoutOpts.dueTime, timeoutOpts.stream) : fetchStream;
}

function memoizeFetch(uri, data, wantJSON, timeoutOpts) {
  return (0, _Memoizer.memoize)(function (uri, data, wantJSON, timeoutOpts) {
    return doFetch(uri, data, wantJSON, timeoutOpts);
  })(uri, data, wantJSON, timeoutOpts);
}

var FetchPeon = exports.FetchPeon = {
  memoizeFetch: memoizeFetch,
  doFetch: doFetch
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/peons/FetchPeon.js
// module id = 41
// module chunks = 0